import { FilterAccess, FilterOrigin, FilterRole, FilterUserExpiresState } from './userFilterTypes';

export const filterAccessDefault: FilterAccess = {
  accessAppDisconnected: false,
  configAppDisconnected: false,
  noGroup: false,
  hasCard: false,
  noCard: false
};

export const filterUserExpiresDefault: FilterUserExpiresState = null;

export const filterRoleDefault: FilterRole = {
  keyManager: false,
  administrator: false,
  installer: false
};

export const filterOriginDefault: FilterOrigin = {
  entraId: false,
  atlas: false,
  keySharing: false
};

export { hasEnabledFilter } from 'v2/filters/hasEnabledFilter';
